import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import Limiter from "../../../../components/atoms/Limiter";
import ExpandLink from "../../../../components/atoms/Limiter/ExpandLink";
import TableSorter from "../../../../components/atoms/TableSorter";
import FusionGdbGenesTable from "./FusionGdbGenesTable";
import { sortStr } from "../../../../common/helpers/helpers";

const sortByFusionSymbol = (a, b) => sortStr(a.fusion_symbol, b.fusion_symbol);
const renderTable = (props) => {
  return <FusionGdbGenesTable {...props} />;
};

const renderLimiter = (props) => {
  return (
    <div className="varsome-inner-container">
      <Limiter
        {...props}
        ExpandLink={(p) => (
          <div className="tw-p-2">
            <ExpandLink {...p} />
          </div>
        )}
        items={props.sortedItems}
        limit={5}
        shouldAutoCollapse={false}
        renderContent={renderTable}
      />
    </div>
  );
};

function FusionGdbGenesContent(props) {
  const { genesList } = props;
  const [formattedItemsList, setFormattedItemsList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const search$ = useRef(new Subject());

  const handleChange = (event) => {
    search$.current.next(event.target.value);
  };

  useEffect(() => {
    setFormattedItemsList(genesList);
  }, [genesList]);

  useEffect(() => {
    const subscription = search$.current
      .pipe(debounceTime(500))
      .subscribe((x) => setSearchTerm(x));
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    const escaped = searchTerm.replace(/[-[/\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    const reg = new RegExp(escaped, "gi");
    const results = formattedItemsList.filter(
      (field) =>
        field.fusion_symbol.match(reg) ||
        field.to_gene_symbol.match(reg) ||
        field.from_gene_symbol.match(reg)
    );
    setSearchResults(results);
  }, [searchTerm, formattedItemsList]);

  return (
    <div className="tw-p-2 tw-inline-block" id="fusion-gdb-genes">
      <h5>Fusion Genes</h5>
      <div className="tw-p-2 tw-inline-block">
        <div className="tw-text-coolGray-400 tw-text-xs tw-flex tw-items-center">
          <div className="tw-mr-1">
            SEARCH FOR FUSION SYMBOL, FROM GENE SYMBOL OR TO GENE SYMBOL:
          </div>
        </div>
        <div className="tw-py-2" style={{ width: "400px" }}>
          <input
            type="text"
            className="form-control tw-mb-2"
            placeholder="fusion symbol, from gene symbol or  to gene symbol"
            onChange={handleChange}
          />
        </div>
      </div>
      <TableSorter
        {...props}
        items={searchResults}
        defaultSortedField="fusion_symbol"
        defaultComparator={sortByFusionSymbol}
        renderContent={renderLimiter}
      />
    </div>
  );
}

FusionGdbGenesContent.propTypes = {
  genesList: PropTypes.arrayOf(
    PropTypes.shape({
      fusion_symbol: PropTypes.string,
      to_gene_symbol: PropTypes.string,
      from_gene_symbol: PropTypes.string,
    })
  ),
};

FusionGdbGenesContent.defaultProps = {
  genesList: [],
};

export default FusionGdbGenesContent;
